import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ALLOWED_FEATURE_KEYS } from '../constants/section-constants/common-constants';
import {
  getAppTabId,
  getAppTabName,
  getSectionListingSortType
} from '../util/util-common';
import LocalStrings from '../assets/languages';

export const useEventTools = () => {
  const userDetails = useSelector(state => state.userDetails);
  const eventDetails = useSelector(state => state.eventDetails);
  const eventTabs = useSelector(state => state.eventTabs);

  const dashboardTypes = useMemo(() => {
    return [
      ...(userDetails?.exhibitoridfk
        ? [
            {
              id: userDetails?.exhibitoridfk,
              type: ALLOWED_FEATURE_KEYS.exhibitor,
              typeText: LocalStrings.dynamic.kExhibitorText,
              tabid: getAppTabId(eventTabs, ALLOWED_FEATURE_KEYS.exhibitor),
              sorttype: getSectionListingSortType(
                eventDetails,
                ALLOWED_FEATURE_KEYS.exhibitor
              ),
              display: `${LocalStrings.dynamic.kExhibitorText} ${LocalStrings.dynamic.kDashboardText}`,
              details: userDetails?.exhibitors_by_exhibitoridfk
            }
          ]
        : []),
      ...(userDetails?.sponsoridfk
        ? [
            {
              id: userDetails?.sponsoridfk,
              type: ALLOWED_FEATURE_KEYS.sponsor,
              typeText: LocalStrings.dynamic.kSponsorText,
              tabid: getAppTabId(eventTabs, ALLOWED_FEATURE_KEYS.sponsor),
              sorttype: getSectionListingSortType(
                eventDetails,
                ALLOWED_FEATURE_KEYS.sponsor
              ),
              display: `${LocalStrings.dynamic.kSponsorText} ${LocalStrings.dynamic.kDashboardText}`,
              details: userDetails?.sponsor_by_sponsoridfk
            }
          ]
        : []),
      ...(userDetails?.speakeridfk
        ? [
            {
              id: userDetails?.speakeridfk,
              type: ALLOWED_FEATURE_KEYS.speaker,
              typeText: getAppTabName(eventTabs, ALLOWED_FEATURE_KEYS.speaker),
              tabid: getAppTabId(eventTabs, ALLOWED_FEATURE_KEYS.speaker),
              sorttype: getSectionListingSortType(
                eventDetails,
                ALLOWED_FEATURE_KEYS.speaker
              ),
              display: `${LocalStrings.dynamic.kMySpeakerProfile}`,
              details: userDetails?.speaker_by_speakeridfk
            }
          ]
        : [])
    ];
  }, [userDetails, eventDetails, eventTabs]);

  return {
    dashboardTypes
  };
};
